import React, {useState} from "react";
import {PermissionPlayer} from "./interfaces";
import SearchInput from "./SearchInput";
import Button from "../../../components/Button";
import {LucideTrash2, LucideUserPlus} from "lucide-react";
import {useOverlay} from "../overlay/OverlayContext";

export default function GroupMembersPanel(props: {
    members: PermissionPlayer[],
    onRemove: (steamId: string) => void,
    onAddClick: () => void
}) {
    const overlay = useOverlay();
    const [search, setSearch] = useState("");
    const query = search.trim().toLowerCase();

    const visible = query
        ? props.members.filter(m => m.displayName.toLowerCase().includes(query) || m.steamId.includes(query))
        : props.members;

    return (
        <div className="space-y-3">
            <div className="flex items-center gap-2">
                <div className="flex-grow">
                    <SearchInput value={search} onChange={setSearch} placeholder="Search members..."/>
                </div>
                <Button text="" className="bg-green-600 flex-shrink-0" onClick={props.onAddClick}>
                    <LucideUserPlus size={18} className="me-2"/> Add players
                </Button>
            </div>

            <div className="space-y-1">
                {visible.map(m => (
                    <div key={m.steamId}
                         className="flex items-center justify-between gap-2 rounded-md px-3 py-2 bg-neutral-800 border border-neutral-700">
                        <div className="min-w-0">
                            <div className="font-medium text-white truncate">
                                <span onClick={() => overlay.openPlayerOverlay(m.steamId)}
                                      className="hover:underline cursor-pointer">
                                    {m.displayName}
                                </span>
                            </div>
                            <div className="text-xs text-neutral-400 font-mono">{m.steamId}</div>
                        </div>
                        <button
                            onClick={() => props.onRemove(m.steamId)}
                            title="Remove from group"
                            className="flex-shrink-0 p-1.5 rounded-md text-red-400 hover:bg-neutral-700 hover:text-red-300">
                            <LucideTrash2 size={18}/>
                        </button>
                    </div>
                ))}
                {visible.length === 0 && (
                    <p className="text-neutral-500 text-sm text-center py-6">
                        {props.members.length === 0 ? "This group has no members." : "No members match your search."}
                    </p>
                )}
            </div>
        </div>
    )
}
